import api, { ensureCsrfCookie } from "./api";

export const register = async (payload) => {
  await ensureCsrfCookie();
  return api.post("/auth/register", payload).then((res) => res.data);
};

export const login = async (payload) => {
  await ensureCsrfCookie();
  return api.post("/auth/login", payload).then((res) => res.data);
};

export const logout = async () => {
  await ensureCsrfCookie();
  return api.post("/auth/logout").then((res) => res.data);
};

// App লোড হওয়ার সময় session আছে কিনা চেক করতে
export const me = () => api.get("/auth/me").then((res) => res.data);
